import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
import auth0 from 'auth0-js';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import LogRocket from 'logrocket';
import AuthenticationContext from '../contexts/AuthenticationContext';
import { updateLastLogin } from '../pages/Registration/api/api';
import { getCookie, setCookie } from '../utils/cookieUtils';
import { getEnvVariable } from '../utils/envUtils';
import Sawmill from '../utils/Sawmill';
import { cancelToken } from './api/api';
var AuthenticationProvider = function (_a) {
  var children = _a.children;
  var EXPIRES_AT_COOKIE = 'expiresIn';
  var AUTH0_SESSION_ACTIVE = 'auth0SessionActive';
  var DPP_AUTH_TOKEN = 'dppAuthToken';
  var _b = useState(true),
    loading = _b[0],
    setLoading = _b[1];
  var _c = useState(),
    user = _c[0],
    setUser = _c[1];
  var _d = useState(),
    auth0Api = _d[0],
    setAuth0Api = _d[1];
  var _e = useState(),
    schedulerId = _e[0],
    setSchedulerId = _e[1];
  var history = useHistory();
  useEffect(function () {
    var init = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var webAuth;
        return __generator(this, function (_a) {
          webAuth = new auth0.WebAuth({
            audience: getEnvVariable('auth0Audience'),
            clientID: getEnvVariable('auth0ClientId'),
            domain: getEnvVariable('auth0Domain'),
            redirectUri: getEnvVariable('auth0RedirectUri'),
            responseType: 'token id_token',
            responseMode: 'form_post',
            scope: 'openid profile email'
          });
          setAuth0Api(webAuth);
          setLoading(false);
          return [2 /*return*/];
        });
      });
    };
    init();
  }, []);
  /**
   * Indicates whether or not there is an authenticated user
   */
  var isAuthenticated = function () {
    var auth0SessionCookie = getCookie(AUTH0_SESSION_ACTIVE);
    var expiresAtCookie = getCookie(EXPIRES_AT_COOKIE);
    if (!!auth0SessionCookie && expiresAtCookie) {
      var expiresAt = JSON.parse(expiresAtCookie);
      return new Date().getTime() < expiresAt;
    }
    return false;
  };
  var handleAuthentication = function (hashFragment) {
    var options = hashFragment ? {
      hash: '#' + hashFragment
    } : {};
    auth0Api.parseHash(options, function (err, authResult) {
      if (authResult && authResult.accessToken && authResult.idToken) {
        setSession(authResult);
      } else if (err) {
        if (err.errorDescription && err.errorDescription.startsWith('Please verify your email before logging in.')) {
          history.push({
            pathname: '/login/verify-email'
          });
        } else {
          //TODO: what to do in the event that this fails
          Sawmill.error(err, 'Unable to handle silent authentication');
          console.log(err);
          // Always redirect to DPP home on logout; that page doesn't need URL params.
          logout();
        }
      }
    });
  };
  var handleAdfsConnection = function () {
    auth0Api === null || auth0Api === void 0 ? void 0 : auth0Api.authorize({
      connection: 'lfg-adfs'
    });
  };
  var setSession = function (authResult) {
    var domainName = getEnvVariable('providerVanityURL');
    var expAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
    var userObj = __assign({
      firstName: authResult.idTokenPayload[domainName + 'firstName'],
      lastName: authResult.idTokenPayload[domainName + 'lastName'],
      previousLogin: authResult.idTokenPayload[domainName + 'previous_login'],
      loginsCount: authResult.idTokenPayload[domainName + 'logins_count'],
      webGUID: authResult.idTokenPayload[domainName + 'webGUID'],
      internalAdmin: authResult.idTokenPayload[domainName + 'role'] === 'INTERNAL',
      role: authResult.idTokenPayload[domainName + 'role'],
      networkSearchEnabled: authResult.idTokenPayload[domainName + 'networkSearchEnabled']
    }, authResult.idTokenPayload);
    setCookie(EXPIRES_AT_COOKIE, expAt);
    setCookie(AUTH0_SESSION_ACTIVE, 'true');
    setCookie(DPP_AUTH_TOKEN, authResult.accessToken || '');
    setUser(userObj);
    var LOGROCKET_APP_ID = getEnvVariable('LOGROCKET_APP_ID');
    if (LOGROCKET_APP_ID) {
      LogRocket.identify(userObj.email, {
        email: userObj.email,
        name: "".concat(userObj.firstName, " ").concat(userObj.lastName),
        internalAdmin: userObj.internalAdmin,
        role: userObj.role,
        webGuid: userObj.webGUID
        //Add any additional user traits
      });
    }
    scheduleRenewal();
    // set lastlogin in auth service
    if (!userObj.internalAdmin) {
      updateLastLogin(authResult.idTokenPayload.updated_at, authResult.idTokenPayload.email, authResult.accessToken);
    }
    // navigate to the home route
    if (history.location.pathname === '/login' || history.location.pathname.startsWith('/v2/callback')) {
      if (!!authResult.state && !!localStorage.getItem(authResult.state)) {
        history.replace(localStorage.getItem(authResult.state));
      } else {
        history.replace('/home', {
          action: 'LOGGED_IN'
        });
      }
    }
  };
  var renewSession = function () {
    auth0Api.checkSession({}, function (err, authResult) {
      if (authResult && authResult.accessToken && authResult.idToken) {
        setSession(authResult);
      } else if (err) {
        logout();
        console.log(err);
      }
    });
  };
  /**
   * Schedules the token set to be renewed 30 seconds prior to expiration
   */
  var scheduleRenewal = function () {
    if (!isAuthenticated()) {
      console.error('Could not schedule renewal as user was never authenticated!');
    } else {
      var expiresAt = getCookie(EXPIRES_AT_COOKIE);
      if (!!expiresAt) {
        clearTimeout(schedulerId);
        var refreshAt = JSON.parse(expiresAt) - 1000 * 30;
        var timeUntilExpiration = Math.max(1, refreshAt - Date.now());
        var schId = window.setTimeout(function () {
          return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
              try {
                renewSession();
              } catch (e) {
                console.error(e);
              }
              return [2 /*return*/];
            });
          });
        }, timeUntilExpiration);
        setSchedulerId(schId);
      } else {
        console.error('Unable to schedule token renewal without expAt');
      }
    }
  };
  var logout = function (params) {
    return __awaiter(void 0, void 0, void 0, function () {
      var e_1, pastTime, redirectUrl, query;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, cancelToken()];
          case 1:
            _a.sent();
            return [3 /*break*/, 3];
          case 2:
            e_1 = _a.sent();
            console.error(e_1);
            return [3 /*break*/, 3];
          case 3:
            pastTime = new Date();
            // Expire cookies
            pastTime.setTime(pastTime.getTime() - 1000 * 60 * 60 * 24);
            setCookie(EXPIRES_AT_COOKIE, ";expires=".concat(pastTime.toUTCString()));
            setCookie(AUTH0_SESSION_ACTIVE, ";expires=".concat(pastTime.toUTCString()));
            setCookie(DPP_AUTH_TOKEN, ";expires=".concat(pastTime.toUTCString()));
            // clear in memory session
            setUser(undefined);
            // clear renew schedule
            clearTimeout(schedulerId);
            redirectUrl = window.location.origin + '/dental/login';
            if (!!params) {
              query = queryString.stringify(params);
              redirectUrl = redirectUrl + '?' + query;
            }
            //invalidate Auth0 session
            auth0Api.logout({
              returnTo: redirectUrl
            });
            return [2 /*return*/];
        }
      });
    });
  };
  var login = function (email, password, errorCallback) {
    var _a;
    var previouslocation = (_a = history.location.state) === null || _a === void 0 ? void 0 : _a.from;
    var dppPreviousLocationNonce = undefined;
    if (!!previouslocation) {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      dppPreviousLocationNonce = btoa(Array.from(bytes, function (b) {
        return String.fromCharCode(b);
      }).join(''));
      localStorage.setItem(dppPreviousLocationNonce, previouslocation.pathname + previouslocation.search + previouslocation.hash);
    }
    auth0Api.login({
      realm: 'Username-Password-Authentication',
      email: email,
      password: password,
      state: dppPreviousLocationNonce
    }, errorCallback);
  };
  return _jsx(AuthenticationContext.Provider, __assign({
    value: {
      user: user,
      loading: loading,
      auth0Api: auth0Api,
      login: login,
      logout: logout,
      handleAuthentication: handleAuthentication,
      handleAdfsConnection: handleAdfsConnection,
      isAuthenticated: isAuthenticated(),
      renewSession: renewSession
    }
  }, {
    children: children
  }));
};
export default AuthenticationProvider;